const num123 = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
const numFas = ['۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰']
const numKor = ['０', '１', '２', '３', '４', '５', '６', '７', '８', '９']
const numMya = ['၀', '၁', '၂', '၃', '၄', '၅', '၆', '၇', '၈', '၉']
const numTel = ['౦', '౧', '౨', '౩', '౪', '౫', '౬', '౭', '౮', '౯']
const _123 = [...num123, ...numFas, ...numKor, ...numMya, ...numTel]
export { _123 }
